import type { VisualizationColorItem } from './types';

export function annotateHiddenColorItems(
  items: VisualizationColorItem[],
  hiddenIds: string[] | undefined,
): VisualizationColorItem[] {
  if (!hiddenIds?.length) return items;
  const hiddenSet = new Set(hiddenIds);
  return items.map((item) => (hiddenSet.has(item.id) ? { ...item, isHidden: true } : item));
}
